
(function () {

  /* This snippet is rendered several times on the homepage. Install its
     controller once so the copies do not observe every divider repeatedly. */
  if (window.__AK_VPCOMPRESS22_CONTROLLER_BOUND__) {
    return;
  }

  window.__AK_VPCOMPRESS22_CONTROLLER_BOUND__ = true;

  /* =====================================================
     PAGE CONTEXT

     IMPORTANT:

     HOMEPAGE:
     PRESERVE EXISTING
     FILM / SPECIAL INTRO FLOW.

     ALL OTHER PAGES:
     VPCOMPRESS IS A NORMAL
     STANDALONE DIVIDER.
  ===================================================== */

  var akVpcompress22IsHomepage =
    document.body.classList.contains('ak-page-index');


  var akVpcompress22MobileFilmReady =
    false;


  var akVpcompress22FilmObserver =
    null;


  var akVpcompress22ResizeBound =
    false;


  var akVpcompress22MobileScrollBound =
    false;


  var akVpcompress22DesktopScrollBound =
    false;


  /* =====================================================
     DESKTOP LINE SYNC

     THE VPCOMPRESS GRID ITSELF
     IS THE SOURCE OF TRUTH.

     ACTUAL RENDERED CELLS:

     CELL 16
     =
     LEFT LINE

     CELL 48
     =
     CENTER LINE

     CELL 80
     =
     RIGHT LINE
  ===================================================== */

  function syncAkVpcompress22DesktopLines() {

    if (
      window.innerWidth <=
      1200
    ) {
      return;
    }


    document
      .querySelectorAll(
        '.ak-vpcompress22-desktop'
      )
      .forEach(
        function (
          section
        ) {

          var sectionRect =
            section.getBoundingClientRect();


          if (
            !sectionRect.width
          ) {
            return;
          }


          var devicePixelRatio =
            window.devicePixelRatio ||
            1;


          function snapToDevicePixel(value) { return window.AKPixels.snap(value); }


          section.style.setProperty(
            '--ak-vpcompress22-line-left',
            snapToDevicePixel(
              sectionRect.width *
              0.25
            ) +
            'px'
          );


          section.style.setProperty(
            '--ak-vpcompress22-line-center',
            snapToDevicePixel(
              sectionRect.width *
              0.50
            ) +
            'px'
          );


          section.style.setProperty(
            '--ak-vpcompress22-line-right',
            snapToDevicePixel(
              sectionRect.width *
              0.75
            ) +
            'px'
          );

        }
      );

  }


  /* =====================================================
     DESKTOP VIEWPORT CHECK

     NORMAL VPCOMPRESS FLOW:

     01 CENTER LINE
     02 230MS LATER
        OUTER LINES

     THIS IS LOCAL TO EACH
     VPCOMPRESS DIVIDER.
  ===================================================== */

  function checkAkVpcompress22DesktopIntro(observedSection, observedRect) {

    if (
      window.innerWidth <=
      1200
    ) {
      return;
    }


    (observedSection ? [observedSection] : document.querySelectorAll('.ak-vpcompress22-desktop'))
      .forEach(
        function (
          section
        ) {

          // The first Papers divider is drawn only after its carousel settles.
          if (section.hasAttribute('data-ak-paper-intro')) return;

          if (
            section.dataset.akVpcompress22DesktopLinesStarted ===
              'true'
          ) {
            return;
          }

          var rect = observedRect ||
            section.getBoundingClientRect();


          if (
            rect.height <=
            0
          ) {
            return;
          }


          if (
            section.dataset.akVpcompress22DesktopLinesStarted !==
              'true' &&
            rect.top <=
              (
                window.innerHeight *
                0.72
              ) &&
            rect.bottom >
              0
          ) {

            section.dataset.akVpcompress22DesktopLinesStarted =
              'true';


            section.classList.add(
              'is-ak-vpcompress22-intro-center'
            );


            window.dispatchEvent(
              new CustomEvent(
                'ak:vpcompress22-desktop-center-start',
                {
                  detail: {
                    section:
                      section
                  }
                }
              )
            );


            window.setTimeout(
              function () {

                section.classList.add(
                  'is-ak-vpcompress22-intro-outer'
                );

              },
              230
            );

          }

        }
      );

  }


  /* =====================================================
     DESKTOP CENTER LINE COMPLETE

     THIS EVENT BELONGS TO THE
     VPCOMPRESS DIVIDER ITSELF.

     IT MAY RELEASE THE CAROUSEL
     DIRECTLY AFTER THIS DIVIDER.

     IT DOES NOT DEPEND ON
     HOMEPAGE TOP / FILM /
     LONGCENTER.
  ===================================================== */

  function bindAkVpcompress22DesktopCenterComplete() {

    if (
      window.innerWidth <=
      1200
    ) {
      return;
    }


    document
      .querySelectorAll(
        '.ak-vpcompress22-desktop'
      )
      .forEach(
        function (
          section
        ) {

          if (
            section.dataset.akVpcompress22CenterCompleteBound ===
              'true'
          ) {
            return;
          }


          var centerLine =
            section.querySelector(
              '.ak-vpcompress22-desktop__line-center'
            );


          if (
            !centerLine
          ) {
            return;
          }


          section.dataset.akVpcompress22CenterCompleteBound =
            'true';


          centerLine.addEventListener(
            'animationend',
            function (
              event
            ) {

              if (
                event.target !==
                  centerLine ||
                event.animationName !==
                  'akVpcompress22DesktopLineDraw'
              ) {
                return;
              }


              if (
                section.dataset.akVpcompress22CenterComplete ===
                  'true'
              ) {
                return;
              }


              section.dataset.akVpcompress22CenterComplete =
                'true';


              window.dispatchEvent(
                new CustomEvent(
                  'ak:vpcompress22-desktop-center-complete',
                  {
                    detail: {
                      section:
                        section
                    }
                  }
                )
              );

            }
          );

        }
      );

  }


  /* =====================================================
     DESKTOP SCROLL
  ===================================================== */

  function bindAkVpcompress22DesktopScroll() {

    if (
      akVpcompress22DesktopScrollBound
    ) {
      return;
    }


    akVpcompress22DesktopScrollBound =
      true;


    var sections =
      document.querySelectorAll(
        '.ak-vpcompress22-desktop'
      );


    if (
      !(
        'IntersectionObserver' in
        window
      )
    ) {

      checkAkVpcompress22DesktopIntro();


      return;

    }


    /* One-shot browser observation replaces the old per-frame desktop
       scroll loop. Excluding the lower 28% preserves the established 72vh
       trigger without forcing layout reads throughout native scrolling. */
    var observer =
      new IntersectionObserver(
        function (
          entries
        ) {

          entries.forEach(
            function (
              entry
            ) {

              if (
                !entry.isIntersecting
              ) {
                return;
              }


              checkAkVpcompress22DesktopIntro(entry.target, entry.boundingClientRect);


              observer.unobserve(
                entry.target
              );

            }
          );

        },
        {
          root:
            null,

          rootMargin:
            '0px 0px -28% 0px',

          threshold:
            0.01
        }
      );


    sections.forEach(
      function (
        section
      ) {

        observer.observe(
          section
        );

      }
    );

  }


  /* =====================================================
     BUILD MOBILE GRID
  ===================================================== */

  function buildAkVpcompress22MobileGrid(
    grid
  ) {

    if (
      !grid ||
      grid.dataset.akVpcompress22MobileBuilt ===
      'true'
    ) {
      return;
    }


    grid.dataset.akVpcompress22MobileBuilt =
      'true';


    var fragment =
      document.createDocumentFragment();


    for (
      var i = 0;
      i <= 24;
      i++
    ) {

      var verticalLine =
        document.createElement(
          'div'
        );


      verticalLine.className =
        'ak-vpcompress22-mobile__vline';


      verticalLine.dataset.akVpcompress22LineIndex =
        String(
          i
        );


      fragment.appendChild(
        verticalLine
      );

    }


    for (
      var row = 1;
      row <= 2;
      row++
    ) {

      var horizontalLine =
        document.createElement(
          'div'
        );


      horizontalLine.className =
        'ak-vpcompress22-mobile__hline';


      horizontalLine.dataset.akVpcompress22RowIndex =
        String(
          row
        );


      fragment.appendChild(
        horizontalLine
      );

    }


    var bottomEdge =
      document.createElement(
        'div'
      );


    bottomEdge.className =
      'ak-vpcompress22-mobile__grid-bottom-edge';


    fragment.appendChild(
      bottomEdge
    );


    grid.appendChild(
      fragment
    );

  }


  /* =====================================================
     MOBILE GRID SYNC

     GEOMETRY ONLY.

     BOTTOM NAV IS USED ONLY
     AS THE PIXEL / GRID
     REFERENCE.

     THIS IS NOT AN INTRO
     OR RELEASE DEPENDENCY.
  ===================================================== */

  window.addEventListener('ak:pixel-ratio-change', function () {
    syncAkVpcompress22DesktopLines();
    syncAkVpcompress22MobileGrid();
  });

  function syncAkVpcompress22MobileGrid() {

    if (
      window.innerWidth >
      1200
    ) {
      return;
    }


    // Build mobile-only geometry on demand, including desktop-to-mobile resize.
    document.querySelectorAll('.ak-vpcompress22-mobile__grid').forEach(buildAkVpcompress22MobileGrid);

    var devicePixelRatio =
      window.devicePixelRatio ||
      1;


    function snapToDevicePixel(value) {
      return window.AKPixels.snap(value);
    }


    document
      .querySelectorAll(
        '.ak-vpcompress22-mobile'
      )
      .forEach(
        function (
          section
        ) {

          var sectionRect =
            section.getBoundingClientRect();


          if (
            !sectionRect.width
          ) {
            return;
          }


          // All endpoints derive from the same unrounded section span.
          // Rounding a cell width before multiplying it moves the centre.
          var gridLeftX = snapToDevicePixel(sectionRect.left + sectionRect.width * 0.125);
          var gridRightX = snapToDevicePixel(sectionRect.left + sectionRect.width * 0.875);
          var localGridLeft = gridLeftX - sectionRect.left;
          var gridWidth = gridRightX - gridLeftX;
          var cellStep = sectionRect.width / 32;

          section.style.setProperty(
            '--ak-vpcompress22-mobile-grid-cell',
            cellStep +
            'px'
          );


          section.style.setProperty(
            '--ak-vpcompress22-mobile-grid-left',
            localGridLeft +
            'px'
          );


          section.style.setProperty(
            '--ak-vpcompress22-mobile-grid-width',
            gridWidth +
            'px'
          );


          var drawnLineLeftX =
            null;


          var drawnLineRightX =
            null;


          section
            .querySelectorAll(
              '.ak-vpcompress22-mobile__vline'
            )
            .forEach(
              function (
                line
              ) {

                var index =
                  Number(
                    line.dataset.akVpcompress22LineIndex
                  );


                var absoluteX;


                absoluteX =
                  sectionRect.left + sectionRect.width * (0.125 + index / 32);


                absoluteX =
                  snapToDevicePixel(
                    absoluteX
                  );


                var localLineX =
                  absoluteX - gridLeftX;


                line.style.setProperty(
                  '--ak-vpcompress22-mobile-line-x',
                  localLineX +
                  'px'
                );


                /* The outer drawn rules must occupy the exact same device
                   pixels as grid columns 4 and 20. Reusing the snapped grid
                   coordinates avoids the independent 25% / 75% rounding
                   that put the rules beside their grid lines on iPhone. */
                if (index === 12) {
                  section.style.setProperty('--ak-vpcompress22-mobile-drawn-line-center',
                    (absoluteX - sectionRect.left) + 'px');
                }

                if (
                  index ===
                  4
                ) {
                  drawnLineLeftX =
                    localGridLeft +
                    localLineX;
                }


                if (
                  index ===
                  20
                ) {
                  drawnLineRightX =
                    localGridLeft +
                    localLineX;
                }


              }
            );


          section.style.setProperty(
            '--ak-vpcompress22-mobile-master-cell',
            (sectionRect.width / 36) +
            'px'
          );


          if (
            drawnLineLeftX !==
            null
          ) {
            section.style.setProperty(
              '--ak-vpcompress22-mobile-drawn-line-left',
              drawnLineLeftX +
              'px'
            );
          }


          if (
            drawnLineRightX !==
            null
          ) {
            section.style.setProperty(
              '--ak-vpcompress22-mobile-drawn-line-right',
              drawnLineRightX +
              'px'
            );
          }


          var grid =
            section.querySelector(
              '.ak-vpcompress22-mobile__grid'
            );


          if (
            !grid
          ) {
            return;
          }


          // The grid belongs to the document. A viewport-relative translateY
          // correction made its settled phase depend on where the user was
          // scrolled when a resize/orientation change happened.
          grid.style.removeProperty('transform');
          var gridRect = grid.getBoundingClientRect();
          var gridTopY = gridRect.top + window.scrollY;
          var scroller = grid.closest('#MainContent');
          if (scroller) gridTopY += scroller.scrollTop;

          grid
            .querySelectorAll(
              '.ak-vpcompress22-mobile__hline'
            )
            .forEach(
              function (
                line
              ) {

                var rowIndex =
                  Number(
                    line.dataset.akVpcompress22RowIndex
                  );


                var absoluteY =
                  gridTopY +
                  (
                    cellStep *
                    rowIndex
                  );


                var snappedAbsoluteY =
                  snapToDevicePixel(
                    absoluteY
                  );


                var localLineY =
                  snappedAbsoluteY -
                  gridTopY;


                line.style.setProperty(
                  '--ak-vpcompress22-mobile-line-y',
                  localLineY +
                  'px'
                );

              }
            );


          var bottomEdge =
            grid.querySelector(
              '.ak-vpcompress22-mobile__grid-bottom-edge'
            );


          if (
            bottomEdge
          ) {

            var bottomAbsoluteY =
              gridTopY +
              (
                cellStep *
                3
              );


            var snappedBottomAbsoluteY =
              snapToDevicePixel(
                bottomAbsoluteY
              );


            var localBottomY =
              snappedBottomAbsoluteY -
              gridTopY;


            bottomEdge.style.setProperty(
              '--ak-vpcompress22-mobile-bottom-edge-y',
              localBottomY +
              'px'
            );

          }

        }
      );

  }


  /* =====================================================
     MOBILE LINE DRAW

     NORMAL LOCAL VPCOMPRESS
     ANIMATION.
  ===================================================== */

  function drawAkVpcompress22MobileLine(
    section
  ) {

    if (
      !section ||
      section.dataset.akVpcompress22LineDrawn ===
        'true'
    ) {
      return;
    }


    section.dataset.akVpcompress22LineDrawn =
      'true';


    var centerLine =
      section.querySelector(
        '.ak-vpcompress22-mobile__line-center'
      );


    if (
      centerLine
    ) {

      var handleCenterLineDrawEnd =
        function (
          event
        ) {

          if (
            event.target !==
              centerLine ||
            event.propertyName !==
              'transform'
          ) {
            return;
          }


          centerLine.removeEventListener(
            'transitionend',
            handleCenterLineDrawEnd
          );


          window.dispatchEvent(
            new CustomEvent(
              'ak:vpcompress22-mobile-center-complete',
              {
                detail: {
                  section:
                    section
                }
              }
            )
          );

        };


      centerLine.addEventListener(
        'transitionend',
        handleCenterLineDrawEnd
      );

    }


    section.classList.add(
      'is-ak-vpcompress22-line-drawing'
    );


    window.setTimeout(
      function () {

        section.classList.add(
          'is-ak-vpcompress22-line-outer'
        );

      },
      300
    );

  }


  /* =====================================================
     MOBILE 60% VIEWPORT WATCH

     NORMAL VPCOMPRESS
     BEHAVIOUR.
  ===================================================== */

  function bindAkVpcompress22MobileLineWatch(
    section
  ) {

    if (
      !section ||
      section.dataset.akVpcompress22LineWatchBound ===
        'true'
    ) {
      return;
    }


    section.dataset.akVpcompress22LineWatchBound =
      'true';


    var observer =
      new IntersectionObserver(
        function (
          entries
        ) {

          entries.forEach(
            function (
              entry
            ) {

              if (
                !entry.isIntersecting ||
                entry.intersectionRatio <
                  0.60
              ) {
                return;
              }


              drawAkVpcompress22MobileLine(
                section
              );


              observer.disconnect();

            }
          );

        },
        {
          root:
            null,

          rootMargin:
            '0px',

          threshold:
            [
              0.60
            ]
        }
      );


    observer.observe(
      section
    );

  }


  /* =====================================================
     HOMEPAGE MOBILE ONLY

     SPECIAL INTRO
     FAST VIEWPORT EXIT

     THIS FUNCTION IS KEPT
     EXACTLY FOR THE HOMEPAGE.

     PAPERS / OTHER PAGES
     NEVER CALL IT.
  ===================================================== */

  function bindAkVpcompress22MobileFastExit(
    section
  ) {

    if (
      !akVpcompress22IsHomepage ||
      !section ||
      section.dataset.akVpcompress22FastExitBound ===
        'true'
    ) {
      return;
    }


    section.dataset.akVpcompress22FastExitBound =
      'true';


    function checkFastExit() {

      if (
        !akVpcompress22IsHomepage ||
        window.innerWidth >
          1200 ||
        !section.classList.contains(
          'is-ak-vpcompress22-special-intro'
        ) ||
        section.dataset.akVpcompress22FastRetractFinished ===
          'true'
      ) {
        return;
      }


      var rect =
        section.getBoundingClientRect();


      if (
        rect.bottom >
        0
      ) {
        return;
      }


      section.dataset.akVpcompress22FastRetractFinished =
        'true';


      var currentHeight =
        section.getBoundingClientRect().height;


      section.style.setProperty(
        '--ak-vpcompress22-mobile-current-height',
        currentHeight +
        'px'
      );


      section.classList.remove(
        'is-ak-vpcompress22-retracting'
      );


      void section.offsetHeight;


      section.classList.add(
        'is-ak-vpcompress22-fast-retract'
      );


      function handleFastRetractEnd(
        event
      ) {

        if (
          event.target !==
            section ||
          event.animationName !==
            'akVpcompress22MobileFastRetract'
        ) {
          return;
        }


        section.removeEventListener(
          'animationend',
          handleFastRetractEnd
        );


        section.classList.remove(
          'is-ak-vpcompress22-fast-retract'
        );


        section.classList.remove(
          'is-ak-vpcompress22-special-intro'
        );


        section.classList.add(
          'is-ak-vpcompress22-line-retracted'
        );


        section.style.removeProperty(
          '--ak-vpcompress22-mobile-current-height'
        );


        requestAnimationFrame(
          function () {

            requestAnimationFrame(
              function () {

                syncAkVpcompress22MobileGrid();


                bindAkVpcompress22MobileLineWatch(
                  section
                );

              }
            );

          }
        );

      }


      section.addEventListener(
        'animationend',
        handleFastRetractEnd
      );

    }


    var frame =
      null;


    function requestFastExitCheck() {

      if (
        frame
      ) {
        return;
      }


      frame =
        requestAnimationFrame(
          function () {

            frame =
              null;


            checkFastExit();

          }
        );

    }


    window.addEventListener(
      'scroll',
      requestFastExitCheck,
      {
        passive:
          true
      }
    );


    window.addEventListener(
      'resize',
      requestFastExitCheck,
      {
        passive:
          true
      }
    );

  }


  /* =====================================================
     HOMEPAGE MOBILE ONLY

     SPECIAL INTRO
     FIRST VPCOMPRESS ONLY.

     PAPERS / OTHER PAGES
     NEVER CALL THIS FUNCTION.
  ===================================================== */

  function startAkVpcompress22MobileSpecialIntro(
    section
  ) {
    if (section && section.hasAttribute('data-ak-mobile-wheel')) return;


    if (
      !akVpcompress22IsHomepage ||
      !section ||
      section.dataset.akVpcompress22SpecialStarted ===
        'true'
    ) {
      return;
    }


    section.dataset.akVpcompress22SpecialStarted =
      'true';


    section.classList.add(
      'is-ak-vpcompress22-special-intro'
    );


    bindAkVpcompress22MobileFastExit(
      section
    );


    function handleSectionRetractEnd(
      event
    ) {

      if (
        event.target !==
          section ||
        event.animationName !==
          'akVpcompress22MobileRetract' ||
        section.dataset.akVpcompress22FastRetractFinished ===
          'true'
      ) {
        return;
      }


      section.removeEventListener(
        'animationend',
        handleSectionRetractEnd
      );


      section.classList.add(
        'is-ak-vpcompress22-line-retracted'
      );


      var centerLine =
        section.querySelector(
          '.ak-vpcompress22-mobile__line-center'
        );


      if (
        !centerLine
      ) {

        bindAkVpcompress22MobileLineWatch(
          section
        );

        return;

      }


      function handleCenterLineRetractEnd(
        transitionEvent
      ) {

        if (
          transitionEvent.target !==
            centerLine ||
          transitionEvent.propertyName !==
            'transform'
        ) {
          return;
        }


        centerLine.removeEventListener(
          'transitionend',
          handleCenterLineRetractEnd
        );


        bindAkVpcompress22MobileLineWatch(
          section
        );

      }


      centerLine.addEventListener(
        'transitionend',
        handleCenterLineRetractEnd
      );

    }


    section.addEventListener(
      'animationend',
      handleSectionRetractEnd
    );


    requestAnimationFrame(
      function () {

        requestAnimationFrame(
          function () {

            section.classList.add(
              'is-ak-vpcompress22-retracting'
            );

          }
        );

      }
    );

  }


  /* =====================================================
     MOBILE NORMAL SECTIONS

     THIS IS THE DEFAULT FLOW
     ON PAPERS / OTHER PAGES.
  ===================================================== */

  function initAkVpcompress22MobileNormalSections(
    firstSection
  ) {

    document
      .querySelectorAll(
        '.ak-vpcompress22-mobile'
      )
      .forEach(
        function (
          section
        ) {

          if (
            section ===
            firstSection &&
            section.classList.contains(
              'is-ak-vpcompress22-special-intro'
            )
          ) {
            return;
          }


          bindAkVpcompress22MobileLineWatch(
            section
          );

        }
      );

  }


  /* =====================================================
     HOMEPAGE MOBILE ONLY

     FILM RELEASE.

     PAPERS / OTHER PAGES
     NEVER USE THIS AS A
     RELEASE MECHANISM.
  ===================================================== */

  function releaseAkVpcompress22Mobile() {

    if (
      !akVpcompress22IsHomepage ||
      window.innerWidth >
      1200
    ) {
      return;
    }


    if (
      akVpcompress22MobileFilmReady
    ) {
      return;
    }


    akVpcompress22MobileFilmReady =
      true;


    window.AK_FILM_MOBILE_COLLAPSE_STARTED =
      true;


    var firstSection =
      document.querySelector(
        '.ak-vpcompress22-mobile, [data-ak-mobile-wheel]'
      );


    if (
      firstSection
    ) {

      startAkVpcompress22MobileSpecialIntro(
        firstSection
      );

    }


    initAkVpcompress22MobileNormalSections(
      firstSection
    );

  }

  /* =====================================================
     MOBILE STATE

     HOMEPAGE:
     PRESERVE EXISTING FILM
     SPECIAL INTRO.

     PAPERS / OTHER PAGES:
     IMMEDIATELY INITIALIZE
     EVERY VPCOMPRESS AS NORMAL.
  ===================================================== */

  function syncAkVpcompress22FilmState() {

    if (
      window.innerWidth >
      1200
    ) {
      return;
    }


    /* ===================================================
       PAPERS / OTHER PAGES

       ABSOLUTELY NO FILM /
       HOMEPAGE TOP RELEASE.

       VPCOMPRESS IS NORMAL
       IMMEDIATELY.
    =================================================== */

    if (
      !akVpcompress22IsHomepage
    ) {

      akVpcompress22MobileFilmReady =
        true;


      initAkVpcompress22MobileNormalSections(
        null
      );


      return;

    }


    /* ===================================================
       HOMEPAGE

       EXISTING FLOW
       PRESERVED.
    =================================================== */

    var firstSection =
      document.querySelector(
        '.ak-vpcompress22-mobile, [data-ak-mobile-wheel]'
      );


    var filmSection =
      document.querySelector(
        '.ak-film-simple-section'
      );


    if (
      !filmSection
    ) {

      akVpcompress22MobileFilmReady =
        true;


      initAkVpcompress22MobileNormalSections(
        firstSection
      );


      return;

    }


    var filmStyle =
      window.getComputedStyle(
        filmSection
      );


    if (
      filmStyle.display ===
      'none'
    ) {

      akVpcompress22MobileFilmReady =
        true;


      initAkVpcompress22MobileNormalSections(
        firstSection
      );

    }

  }


  /* =====================================================
     HOMEPAGE MOBILE ONLY

     FILM OBSERVER.

     PAPERS / OTHER PAGES:
     NO OBSERVER IS CREATED.
  ===================================================== */

  function bindAkVpcompress22FilmObserver() {

    if (
      !akVpcompress22IsHomepage ||
      window.innerWidth >
      1200
    ) {
      return;
    }


    if (
      akVpcompress22FilmObserver
    ) {
      return;
    }


    var filmSection =
      document.querySelector(
        '.ak-film-simple-section'
      );


    if (
      !filmSection
    ) {

      syncAkVpcompress22FilmState();

      return;

    }


    akVpcompress22FilmObserver =
      new MutationObserver(
        function () {

          if (
            filmSection.classList.contains(
              'ak-film-collapse'
            )
          ) {

            releaseAkVpcompress22Mobile();


            akVpcompress22FilmObserver.disconnect();


            akVpcompress22FilmObserver =
              null;

          }

        }
      );


    akVpcompress22FilmObserver.observe(
      filmSection,
      {
        attributes:
          true,

        attributeFilter:
          [
            'class',
            'style'
          ]
      }
    );

  }


  /* =====================================================
     MOBILE SCROLL FALLBACK

     WORKS LOCALLY FOR
     NORMAL VPCOMPRESS SECTIONS.
  ===================================================== */

  function bindAkVpcompress22MobileScroll() {

    if (
      akVpcompress22MobileScrollBound
    ) {
      return;
    }


    akVpcompress22MobileScrollBound =
      true;


    window.addEventListener(
      'scroll',
      function () {

        if (
          window.innerWidth >
          1200
        ) {
          return;
        }


        document
          .querySelectorAll(
            '.ak-vpcompress22-mobile'
          )
          .forEach(
            function (
              section
            ) {

              if (
                section.dataset.akVpcompress22LineDrawn ===
                  'true' ||
                section.classList.contains(
                  'is-ak-vpcompress22-special-intro'
                )
              ) {
                return;
              }


              var rect =
                section.getBoundingClientRect();


              var visibleTop =
                Math.max(
                  rect.top,
                  0
                );


              var visibleBottom =
                Math.min(
                  rect.bottom,
                  window.innerHeight
                );


              var visibleHeight =
                Math.max(
                  0,
                  visibleBottom -
                  visibleTop
                );


              if (
                rect.height >
                  0 &&
                (
                  visibleHeight /
                  rect.height
                ) >=
                  0.60
              ) {

                drawAkVpcompress22MobileLine(
                  section
                );

              }

            }
          );

      },
      {
        passive:
          true
      }
    );

  }


  /* =====================================================
     RESIZE
  ===================================================== */

  function bindAkVpcompress22Resize() {

    if (
      akVpcompress22ResizeBound
    ) {
      return;
    }


    akVpcompress22ResizeBound =
      true;


    window.addEventListener(
      'resize',
      function () {

        requestAnimationFrame(
          function () {

            syncAkVpcompress22DesktopLines();

            checkAkVpcompress22DesktopIntro();

            syncAkVpcompress22MobileGrid();


            /*
              HOMEPAGE:
              SYNC FILM STATE.

              OTHER PAGES:
              THIS INITIALIZES
              NORMAL MOBILE
              VPCOMPRESS ONLY.
            */

            syncAkVpcompress22FilmState();

          }
        );

      },
      {
        passive:
          true
      }
    );

  }


  /* =====================================================
     INIT
  ===================================================== */

  function initAkVpcompress22() {

    requestAnimationFrame(
      function () {

        syncAkVpcompress22DesktopLines();

      }
    );


    bindAkVpcompress22DesktopCenterComplete();

    checkAkVpcompress22DesktopIntro();

    bindAkVpcompress22DesktopScroll();





    syncAkVpcompress22MobileGrid();


    /* ===================================================
       HOMEPAGE VS OTHER PAGES

       THIS IS THE IMPORTANT
       SEPARATION.
    =================================================== */

    akVpcompress22MobileFilmReady =
      true;


    initAkVpcompress22MobileNormalSections(
      null
    );


    bindAkVpcompress22MobileScroll();

    bindAkVpcompress22Resize();

  }


  /* =====================================================
     DOM READY
  ===================================================== */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initAkVpcompress22
    );

  }

  else {

    initAkVpcompress22();

  }


  /* =====================================================
     LOAD
  ===================================================== */

  window.addEventListener(
    'load',
    function () {

      requestAnimationFrame(
        function () {

          syncAkVpcompress22DesktopLines();

          checkAkVpcompress22DesktopIntro();

          syncAkVpcompress22MobileGrid();

        }
      );

    }
  );


  /* =====================================================
     NAV GRID EVENT

     GEOMETRY SYNC ONLY.
  ===================================================== */

  window.addEventListener(
    'ak-nav-grid-synced',
    function () {

      requestAnimationFrame(
        function () {

          syncAkVpcompress22DesktopLines();

        }
      );

    }
  );


  /* =====================================================
     BOTTOM NAV GRID EVENT

     GEOMETRY SYNC ONLY.
  ===================================================== */

  window.addEventListener(
    'ak-bottom-nav-grid-synced',
    function () {

      requestAnimationFrame(
        function () {

          syncAkVpcompress22DesktopLines();

          syncAkVpcompress22MobileGrid();

        }
      );

    }
  );


  /* =====================================================
     SAFARI / BFCACHE
  ===================================================== */

  window.addEventListener(
    'pageshow',
    function () {

      requestAnimationFrame(
        function () {

          syncAkVpcompress22DesktopLines();

          checkAkVpcompress22DesktopIntro();

          syncAkVpcompress22MobileGrid();


          initAkVpcompress22MobileNormalSections(
            null
          );

        }
      );

    }
  );


  /* =====================================================
     SHOPIFY EDITOR
  ===================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {

      requestAnimationFrame(
        function () {

          initAkVpcompress22();

          syncAkVpcompress22DesktopLines();

          checkAkVpcompress22DesktopIntro();

        }
      );

    }
  );

})();


/* Reveal each icon when its existing stroke reaches the circle. The original
   line animations and completion events still own the following section. */
(() => {
  const desktop = matchMedia('(min-width:1201px)');
  const records = new Map();
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const main = document.querySelector('#MainContent');
  const activeRotations = new Set();
  let frame = 0, spinFrame = 0, lastTime = 0, lastScrollTime = 0;
  let speed = 4.5, direction = 1, boost = 0;
  let lastOffset = window.scrollY + (main?.scrollTop || 0);
  function syncRotations() {
    activeRotations.clear();
    records.forEach(record => record.circles.forEach(item => {
      if (!item.rotation && item.circle.hasAttribute('data-ak-circle-reached')) {
        const owner = item.circle.querySelector('.ak-catalogue-entry-emblem');
        item.rotation = owner.animate([{transform:'rotate(0deg)'},{transform:'rotate(360deg)'}], {
          duration:80000, iterations:Infinity, easing:'linear'
        });
        // Leave room to rotate backwards through zero without hitting the
        // beginning of the animation. No angle is reset on direction changes.
        item.rotation.currentTime = 800000000;
        item.rotation.pause();
      }
      if (!item.rotation) return;
      const running = item.visible && desktop.matches && !reduced.matches && !document.hidden;
      if (running) {
        item.rotation.updatePlaybackRate(speed/4.5);
        if (item.rotation.playState !== 'running') item.rotation.play();
        activeRotations.add(item.rotation);
      } else if (item.rotation.playState !== 'paused') item.rotation.pause();
    }));
  }
  function spin(now) {
    spinFrame = 0;
    if (!activeRotations.size || !desktop.matches || reduced.matches || document.hidden) {lastTime = 0; return;}
    const dt = Math.min(64,lastTime ? now-lastTime : 16);
    lastTime = now;
    const remainingBoost = boost * Math.exp(-Math.max(0,now-lastScrollTime)/220);
    const target = direction * (4.5 + remainingBoost);
    speed += (target-speed) * (1-Math.exp(-dt/120));
    activeRotations.forEach(animation => animation.updatePlaybackRate(speed/4.5));
    if (remainingBoost > .1 || Math.abs(speed-direction*4.5) > .1) {
      spinFrame = requestAnimationFrame(spin);
    } else {
      speed = direction*4.5;
      activeRotations.forEach(animation => animation.updatePlaybackRate(direction));
      lastTime = 0;
    }
  }
  function startSpin() {
    if (!spinFrame && activeRotations.size && desktop.matches && !reduced.matches && !document.hidden) spinFrame = requestAnimationFrame(spin);
  }
  document.addEventListener('scroll',() => {
    const offset = window.scrollY + (main?.scrollTop || 0);
    const delta = offset-lastOffset;
    lastOffset = offset;
    if (!desktop.matches || !delta) return;
    const now = performance.now();
    direction = Math.sign(delta);
    boost = Math.min(240,Math.max(45,Math.abs(delta)/Math.max(8,now-lastScrollTime)*100));
    lastScrollTime = now;
    startSpin();
  },{capture:true,passive:true});
  function queue() {
    if (!frame && desktop.matches && !document.hidden) frame = requestAnimationFrame(check);
  }
  function check() {
    frame = 0;
    if (!desktop.matches || document.hidden) return;
    let drawing = false;
    records.forEach((record, section) => {
      if (!record.visible || section.hasAttribute('data-ak-paper-intro')) return;
      record.circles.forEach(({circle, line}) => {
        if (circle.hasAttribute('data-ak-circle-reached')) return;
        const stroke = line.getBoundingClientRect();
        const ring = circle.getBoundingClientRect();
        if (ring.width > 0 && stroke.height > 0 && stroke.bottom >= ring.top) {
          circle.setAttribute('data-ak-circle-reached', '');
        } else if (line.getAnimations().some(animation => animation.playState === 'running' || animation.playState === 'pending')) {
          drawing = true;
        }
      });
    });
    syncRotations();
    startSpin();
    if (drawing) queue();
  }
  const visibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const record = records.get(entry.target);
      if (!record) return;
      record.visible = entry.isIntersecting;
      entry.target.toggleAttribute('data-ak-divider-circles-visible', entry.isIntersecting);
    });
    queue();
  });
  const circleVisibility = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      records.forEach(record => record.circles.forEach(item => {
        if (item.circle === entry.target) item.visible = entry.isIntersecting;
      }));
    });
    syncRotations();
    startSpin();
  });
  function init() {
    document.querySelectorAll('.ak-vpcompress22-desktop').forEach(section => {
      if (records.has(section)) return;
      const circles = Array.from(section.querySelectorAll('[data-ak-divider-circle]')).map(circle => ({
        circle, visible:false, line:section.querySelector(`.ak-vpcompress22-desktop__line-${circle.dataset.akDividerCircle}`)
      })).filter(item => item.line);
      if (!circles.length) return;
      records.set(section, {circles, visible:false});
      // Attribute changes cover the Papers WAAPI entrance and committed strokes;
      // animationstart covers the normal and staggered CSS drawing sequence.
      const changes = new MutationObserver(queue);
      changes.observe(section, {attributes:true, attributeFilter:['class','data-ak-paper-intro']});
      circles.forEach(({line}) => changes.observe(line, {attributes:true, attributeFilter:['style','data-ak-paper-line-drawn']}));
      section.addEventListener('animationstart', event => {
        if (event.animationName === 'akVpcompress22DesktopLineDraw') queue();
      });
      visibility.observe(section);
      circles.forEach(item => circleVisibility.observe(item.circle));
    });
    queue();
  }
  desktop.addEventListener('change', () => {syncRotations(); queue();});
  reduced.addEventListener('change', () => {syncRotations(); queue();});
  window.addEventListener('resize', queue, {passive:true});
  window.addEventListener('pageshow', queue);
  document.addEventListener('visibilitychange', () => {syncRotations(); queue();});
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
